// utils/event-bus.js
import mitt from 'mitt'
export const EventBus = new mitt()